import { customTheme } from '@upright/ui/common/generic/theme/custom-theme';
import { StylesConfig } from 'react-select';
import { BouColor } from '../../../../../generic/global/bou-colors';
import { searchBackgroundColor } from './shared';

// https://react-select.com/styles
export const selectStyles: StylesConfig<any> = {
  container: base => ({
    ...base,
    letterSpacing: 0,
    zIndex: 150,
  }),
  valueContainer: base => ({
    ...base,
    borderRadius: 4,
    color: BouColor.PLATFORM_ICON_GRAY,
    padding: '0 1em',
  }),
  control: base => ({
    ...base,
    width: '90vw',
    maxWidth: 360,
    backgroundColor: searchBackgroundColor,
    borderColor: BouColor.PLATFORM_BORDER_GRAY_DARK,
    '&:hover': {
      borderColor: BouColor.PLATFORM_BORDER_GRAY_DARK,
    },
    boxShadow: undefined,
    display: 'flex',
    fontSize: customTheme.fontSizes[0],
    fontWeight: 500,
  }),
  placeholder: (base, state: { isFocused: boolean }) => ({
    ...base,
    display: state.isFocused ? 'none' : 'block',
    color: BouColor.PLATFORM_TEXT_GRAY_LIGHTER,
    fontWeight: 500,
  }),
  clearIndicator: base => ({
    ...base,
    cursor: 'pointer',
  }),
  menu: base => ({
    ...base,
    marginTop: '4px',
    width: '90vw',
    maxWidth: 740,
    backgroundColor: searchBackgroundColor,
    borderColor: BouColor.PLATFORM_BORDER_GRAY_DARK,
    borderRadius: 4,
    borderWidth: 1,
    color: BouColor.PLATFORM_TEXT_WHITE,
  }),
  menuList: base => ({
    ...base,
  }),
};
